// export image files with webpack
const requireIllustrations = () => {
  const req = require.context('.', true, /.*\.(svg|png)$/)
  return req.keys().reduce<Record<string, string>>((acc, key) => {
    const name = key.match(/(?:undraw.)?([.\w-]*)\.(\w*)$/i)![1]
    acc[name] = req(key).default || req(key)
    return acc
  }, {})
}
export default requireIllustrations()
